import React, { Component } from "react";

export default class input extends Component {
  state = {
    value: this.props.defaultValue,
  };
  render() {
    return (
      <div className="input-rapper">
        <p className="label">{this.props.label}</p>

        <div className="select-tip-rapper">
          <select
            {...this.props}
            autoFocus={this.props.autoFocus ? true : false}
          >
            {this.props.placeholder ? (
              <option value="" disabled>
                {this.props.placeholder}
              </option>
            ) : (
              ""
            )}

            {this.props.children}
          </select>
          <span className="tip"></span>
        </div>
      </div>
    );
  }
}
